import { render, staticRenderFns } from "./ModalAddDevisDetails.vue?vue&type=template&id=15beef72&"
import script from "./ModalAddDevisDetails.vue?vue&type=script&lang=js&"
export * from "./ModalAddDevisDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports